module.exports = __webpack_public_path__ + "img/rupay.c644cf13.jpg";